import React, { Component } from 'react';
import { Redirect, withRouter } from "react-router-dom";
import API                  from './server_api'

import './Login.css'

let accessToken = null;
let expiresAt   = 0;
let me          = null;

function loggedIn (json) {
    accessToken = json.token;
    expiresAt   = (json.expiresIn * 1000) + new Date().getTime();
    localStorage.setItem('session_key', json.session_key);
}

export function getToken(){
    return accessToken;
}

export function getMe(){
    return me;
}

export function updateMe(json){
    me=json;
}

export function isAuthenticated () {
    if ( accessToken === null || me === null ) {
        return false;
    }
    else {
        const now = new Date().getTime();
        // через 10 минут устареет? надо бы обновить. Обычно они на час выдаются
        if ( now + 10*60*1000 >= expiresAt ){
            let session_key = localStorage.getItem('session_key');            
            API.renewAccessToken(loggedIn, session_key);
        }
        // пока считаем, что все норм, токен есть и он не очень старый, либо вот-вот обновится
        return true;
    }
}

export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            logged_in:   isAuthenticated(), // есть ли уже токен доступа к серверу и  информация о пользователе ?

            restoring_session: false,       // на время восстановления старой сессии не будем ничего рисовать на экране, чтобы не мелькало
            return_to:   { pathname: '/' }, // куда вернемся после восстановления сессии - если не было сюда явного редиректа - вернемся в корень

            inputEmail:  '',                // поля ввода в форме
            inputCode:   '',

            wrong_email: false,             // состояния UI
            wrong_code:  false,             // состояния UI
            code_sent:   false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.performLogIn      = this.performLogIn.bind(this);

        // запоминаем, откуда нас сюда заредиректили, чтобы потом вернуться
        if ( this.props.location.state !== undefined )
            this.state.return_to =  this.props.location.state.from;

        // может быть не аутентифицированы сейчас, но были при прошлом посещении страницы?
        let session_key = localStorage.getItem('session_key');            
        if ( accessToken === null &&  session_key ) {
            // флаг, предотвращающий мелькание экрана
            this.state.restoring_session = true;
            // на случай ошибки сбрасываем флаг наличия сессии, чтобы не было бесконечного цикла
            localStorage.removeItem('session_key');
            // пытаемся восстановить токен с сервера 
            API.renewAccessToken(result=>{
                loggedIn(result);
                API.getMe((json) => {
                    me = json;
                    this.setState({ logged_in: true })
                });
            }, session_key, ()=>{
                // попытка залогиниться не прошла, рисуем форму логина
                this.setState({ restoring_session: false })
            });
        }

        // странная ситуация - есть токен, но не загружена информация о себе - загружаем
        if ( accessToken !== null && me === null ) {
            API.getMe((json) => {
                me = json;
                this.setState({ logged_in: true })
            });
        }
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({ [target.id]: target.value, wrong_email: false, wrong_code: false });
    }

    performLogIn(event){
        if ( this.state.code_sent === false ){ 
            API.startEmailAuthentification(json=>{
                this.setState ({ code_sent: true, wrong_email: false, temp_key: json.session_key });
            }, this.state.inputEmail, ()=>{
                this.setState ({ code_sent: false, wrong_email: true });
            });
        }
        else {
            API.finishEmailAuthentification(json=>{
                loggedIn(json);
                this.setState ({ logged_in: true });
            }, this.state.temp_key, this.state.inputCode, ()=>{
                this.setState ({ wrong_code: true });
            });
        }
        event.preventDefault();
    }
    
    render () {
        const no_user = this.state.wrong_email;
        const wrong_code = this.state.wrong_code;

        if ( this.state.logged_in )
            return <Redirect to={this.state.return_to} />;
        else if ( this.state.restoring_session )
            return <center><h4 className='p-4 text-muted'>Logging in, please wait...</h4></center> ; // не мелькаем экраном на вермя восстановления сессии
        else
            return (
            <main>
                <form className="form-signin text-center my-5" onSubmit = { this.performLogIn }>
                    <img className="mb-4" src="https://www.nodelfilms.com/assets/icons/nodelfilms-icon.svg" alt="" width="72" height="72" />
                    <h1 className="h3 mb-3 font-weight-normal">
                        Вход только для зарегистрированны пользователей
                    </h1>
                    {
                        this.state.code_sent && 
                        <p className='text-secondary'>
                            Код подтверждения отправлен на указанную почту. Для входа, введите код в поле ниже:
                        </p>
                    }
                    <div className="input-group">
                        { this.state.code_sent || 
                            <div className="input-group-prepend">
                                <span className="input-group-text">@</span>
                            </div>
                        }
                    <input type= { this.state.code_sent ? 'hidden' : 'email' }
                           id="inputEmail" 
                           className={ no_user ? "form-control is-invalid" : "form-control" }
                           placeholder="Email" 
                           value={this.state.inputEmail} 
                           onChange={this.handleInputChange}
                           autoFocus={true}/>
                    { no_user &&
                        <div className="invalid-feedback">
                            Пользователь не зарегистрирован
                        </div>
                    }
                    </div>
                    <input type={ this.state.code_sent ? 'number' : 'hidden' }
                           id="inputCode"
                           className={ wrong_code ? "form-control is-invalid" : "form-control" }
                           placeholder="Код из письма" 
                           value={this.state.inputCode} 
                           onChange={this.handleInputChange}
                           autoFocus={true}/>
                    { wrong_code &&
                        <div className="invalid-feedback">
                            Неверный код
                        </div>
                    }
                    <button className="btn btn-primary btn-block my-2" type="submit" disabled={wrong_code} >
                        { this.state.code_sent ? ' Проверить код' : ' Получить код для входа' }
                    </button>
                    <p className="mt-5 mb-3 text-muted">
                        © 2019, nodelfilms.com
                    </p>
                </form>
            </main> 
        );
    }    
}

export const Logout = withRouter((props) => {
    if ( accessToken !== null ){
        // Remove session_key from localStorage
        let session_key = localStorage.getItem('session_key'); 

        me = null;
        accessToken = null;
        localStorage.removeItem('session_key');

        function redirect () {
            props.history.push("/login");            
        }
    
        API.logout(redirect, session_key, redirect);

        // это будет отображено на экране на короткое время, 
        // пока идет запрос к серверу авторизации
        // потом будет редирект страницу логина
        return (<center><h4 className='p-4 text-muted'>Logging out, please wait...</h4></center>);
    }
    else{
        return <Redirect to={'/login'} />;
    }
});